module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/X0gmyU/tc-custom/9781685506780.jpg?1723403856186",
      "alt": "This image is the cover for the book Waiting in Line"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Waiting in Line\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("As a personal assistant, Tristan does just about everything for his boss. So, he's not surprised when Dante asks him to travel along to a wedding reception in the country and help the two grooms with their plans. He's not even surprised Dante has requested Gavin, Dante's security officer and Tristan's arch-enemy, to come as well."), _c('br'), _c('br'), _vm._v("Gavin is sexy, smart, struts like a peacock, and does everything he can to drive Tristan crazy on a daily basis. So as much as Gavin's presence was expected, Tristan isn't happy about it, and he's really not happy about having to sleep on a cot in a barn while Gavin gets to stay in the farmhouse in an actual bedroom."), _c('br'), _c('br'), _vm._v("When a little flirting gets Tristan into yet another argument with Gavin, things start to get heated between them -- in a way they never have before. As they start to learn a bit more about each other, Tristan is having a hard time deciding if the country air is messing with his head, or if there's a possibility the disgust he's been feeling for Gavin isn't actually hate at all.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      A.F. Henley\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0